module.exports = __webpack_public_path__ + "static/media/builtinv2-umniy.044652ff.png";